<template>
  <div class="bind_modal">

    <div class="bind_modal__header">
      <h4 class="title">
        {{ translate('device.simcard_binding.linking_sim') }}
      </h4>
    </div>

    <div class="top">
      <div class="rules" v-if="new_binding.id">
        <label> {{ translate("device.simcard_binding.rule") }}</label>
        <tree-select
          :options="rule_list"
          :multiple="false"
          v-model="new_binding.settings.rule"
          :placeholder="translate('device.simcard_binding.rule')"
          :clearable="false"
          :searchable="true"
        />
      </div>

      <div class="filter checkbox">
        <div class="status">
          <div class="info">
            {{ translate("device.simcard_binding.status") }}
          </div>
          <label
            class="switch"
            @click.prevent="new_binding.status = !new_binding.status"
          >
            <input type="checkbox" v-model="new_binding.status" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <span class="button">
        <button
          class="btn btn-success btn-fill"
          @click="save_simcard_binding()"
          :disabled="!check_save"
        >
          {{ translate("save") }}
        </button>
      </span>
    </div>

    <div class="content">
      <BindItem
        ref="bind_list"
        v-for="(item, key) in new_binding.items"
        :key="key"
        :item_key="key"
        :item="item"
        @delete_bind="delete_bind"
        :for_current_slot="for_current_slot"
      />
    </div>

    <div class="bottom">
      <div class="new_bind">
        <span
            class="btn btn-success btn-fill btn-wd"
            @click="add_bind('physical')"
        >
          {{ translate("device.physical_sim") }}
        </span>

        <span
            class="btn btn-success btn-fill btn-wd"
            @click="add_bind('remote')"
        >
          {{ translate("device.remote_sim") }}
        </span>
      </div>

      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="close"
      >
        {{ translate("close_modal") }}
      </span>
    </div>
  </div>
</template>
<script>
import BindItem from "./Item/Index.vue";

export default {
  name: "SimcardBindingModal",
  components: {
    BindItem,
  },
  props: ["device_id", "simcard_binding", "simcard_list"],
  data() {
    return {
      new_binding: {},
      check_save: true,
      for_current_slot: [],
    };
  },
  watch: {
    new_binding: {
      deep: true,
      handler() {
        for (let item of this.new_binding.items) {
          if (!item.is_remote_sim){
            this.check_save = !!item.simcard_id;
          }
        }
      },
    },
  },
  computed: {
    rule_list() {
      return [
        { id: "match", label: "match" },
        { id: "any", label: "any" },
        { id: "client_pool", label: "client_pool" },
      ];
    },
  },
  created() {
    if (this.simcard_binding?.id && this.simcard_binding?.items.length > 0) {
      this.new_binding = JSON.parse(JSON.stringify(this.simcard_binding));
    } else {
      this.get_template();
    }
    this.current_slot();
  },
  methods: {
    current_slot() {
      for (let i of this.new_binding.items) {
        this.simcard_list.forEach((item) => {
          if (i.imsi === item.imsi && item.active === 1) {
            this.for_current_slot.push(item);
          }
        });
      }
    },
    close() {
      this.$emit("close");
    },

    get_template() {
      this.$http.v1.getTemplateSimcardBinding(this.device_id, (response) => {
        this.new_binding = response.data;
      });
    },

    save_simcard_binding() {
      for (let i in this.new_binding.items) {
        this.new_binding.items[i].slot = parseInt(this.new_binding.items[i].slot)
      }
      if (this.new_binding.id) {
        this.$http.v1.updateBindSimcardBinding(this.new_binding.id, this.new_binding, () => {
            this.global_notify("info", this.translate("device.simcard_binding.updated"));
            this.$emit("update");
            this.close();
          }
        );
      } else {
        this.$http.v1.createBindSimcardBinding(this.new_binding, () => {
          this.global_notify("info", this.translate("device.simcard_binding.created"));
          this.$emit("update");
          this.close();
        });
      }
    },
    add_bind(type) {
      let new_bind = {}
      if (type === "remote"){
        new_bind = {
          slot: null,
          status: true,
          new: true,
          is_remote_sim: true
        }
      } else {
        new_bind = {
          iccid: "",
          imsi: "",
          msisdn: "",
          slot: null,
          status: true,
          new: true,
          is_remote_sim: false
        }
      }

      this.new_binding.items.push(new_bind);
    },

    delete_bind(key) {
      this.new_binding.items.splice(key, 1);
    },
  },
};
</script>

<style lang='scss' scoped>
.bind_modal {
  padding: 10px;
  &__header{
    .title{
      text-align: center;
      margin-bottom: 0;
      margin-top: 10px;
    }
  }
  .top {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

  }
  .content {
    padding: 10px;
    max-height: 400px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 10px;
    }
  }
  .bottom {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .new_bind {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 10px;
    }
    .btn {
      margin: 0 5px;
      display: block;
    }
  }
}
</style>
